import type { ModelsActiveFilter } from "@/lib/manufacturing/filterManufacturingModels";
import { ghostBtnClass, inputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

type Props = {
  search: string;
  onSearchChange: (next: string) => void;
  activeFilter: ModelsActiveFilter;
  onActiveFilterChange: (next: ModelsActiveFilter) => void;
  needsReviewOnly?: boolean;
  onNeedsReviewOnlyChange?: (next: boolean) => void;
  recipeGroupId?: string;
  onRecipeGroupIdChange?: (next: string) => void;
  recipeGroups?: ReadonlyArray<{ id: string; code: string; name: string }>;
  bulkEnabled?: boolean;
  filteredCount?: number;
  allFilteredSelected?: boolean;
  onSelectAllFiltered?: () => void;
};

export function ManufacturingModelsRecipeListToolbar(props: Props) {
  return (
    <div className="space-y-2 border-b border-gray-100 pb-3 dark:border-zinc-700">
      <input
        className={inputClass}
        value={props.search}
        onChange={(e) => props.onSearchChange(e.target.value)}
        placeholder="Search code, name, kind, tags — commas AND (e.g. barn, loft)…"
        autoComplete="off"
      />
      <div className="flex flex-wrap items-center gap-2">
        <select
          className={`${inputClass} min-w-[10rem] flex-1`}
          value={props.activeFilter}
          onChange={(e) => props.onActiveFilterChange(e.target.value as ModelsActiveFilter)}
          aria-label="Active filter"
        >
          <option value="active">Active only</option>
          <option value="inactive">Inactive only</option>
          <option value="all">All models</option>
        </select>
        {props.onRecipeGroupIdChange ? (
          <select
            className={`${inputClass} min-w-[10rem] flex-1`}
            value={props.recipeGroupId ?? ""}
            onChange={(e) => props.onRecipeGroupIdChange?.(e.target.value)}
            aria-label="Recipe group filter"
          >
            <option value="">All groups</option>
            <option value="__ungrouped__">Ungrouped</option>
            {(props.recipeGroups ?? []).map((g) => (
              <option key={g.id} value={g.id}>
                {g.name}
              </option>
            ))}
          </select>
        ) : null}
        {props.onNeedsReviewOnlyChange ? (
          <button
            type="button"
            className={
              props.needsReviewOnly
                ? "rounded-md bg-amber-100 px-2.5 py-1.5 text-xs font-medium text-amber-900 dark:bg-amber-900/40 dark:text-amber-100"
                : `${ghostBtnClass} text-xs`
            }
            onClick={() => props.onNeedsReviewOnlyChange?.(!props.needsReviewOnly)}
            aria-pressed={Boolean(props.needsReviewOnly)}
          >
            Needs review
          </button>
        ) : null}
        {props.bulkEnabled && props.onSelectAllFiltered && (props.filteredCount ?? 0) > 0 ? (
          <button
            type="button"
            className={`${ghostBtnClass} text-xs`}
            onClick={props.onSelectAllFiltered}
          >
            {props.allFilteredSelected
              ? `All ${props.filteredCount} selected`
              : `Select filtered (${props.filteredCount})`}
          </button>
        ) : null}
      </div>
    </div>
  );
}
